import Button from 'common/components/Button/Button';
import PageHeader from 'common/components/PageHeader/PageHeader';
import Table from 'common/components/Table/Table';
import useRouter from 'common/hooks/use-router';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useItem from '../../../common/hooks/useItem';
import useList from '../../../common/hooks/useList';

const Companies = () => {
  const { t } = useTranslation();
  const {
    fetchItems,
    items,
    isFetching,
    filters,
    setFilter,
    pageCount,
    removeListItem,
  } = useList('companies', {
    defaultFilters: {},
    defaultSort: 'name:ASC',
    cachePrefix: 'companies',
  });
  const {
    removeItem,
  } = useItem('companies');
  const { push } = useRouter();

  const handleDelete = useCallback(async (id) => {
    removeListItem(id);
    await removeItem(id);
    await fetchItems();
  }, [fetchItems, removeItem, removeListItem]);

  const columns = useMemo(() => [
    {
      Header: t('company.name'),
      filterName: 'name_contains',
      Cell: ({ row: { original: { id, name } } }) => (
        <span className="clickable" onClick={() => push(`/companies/edit/${id}`)}>{name}</span>
      ),
    },
    {
      Header: t('common.actions'),
      className: 'table-actions',
      // eslint-disable-next-line
      Cell: ({ row: { original: { id } } }) => {

        return (
          <>
            <Button
              onClick={() => push(`/companies/edit/${id}`)}
              icon="fa-pencil-alt"
              color="primary"
              transparent
            />
            <Button
              // eslint-disable-next-line react/prop-types
              onClick={() => handleDelete(id)}
              icon="fa-trash-alt"
              color="danger"
              confirm
              transparent
              confirmMessage={t('common.delete')}
            />
          </>
        );
      },
    },
  ], [t, push, handleDelete]);

  return (
    <>
      <PageHeader
        title={t('common.companies')}
        link={{ url: '/companies/add', icon: 'plus', label: t('common.add') }}
        subLink={{
          url: '/configure',
          icon: 'arrow-left',
          goBack: true,
          label: t('common.back'),
        }}
      />
      <section className="section list-page list-action">
        <Table
          data={items || []}
          columns={columns}
          fetchData={fetchItems}
          isFetching={isFetching}
          pageCount={pageCount}
          filters={filters}
          setFilter={setFilter}
        />
      </section>
    </>
  );
};

export default Companies;
